import React, { FC } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { withRouter } from 'next/router';
import { WithRouterProps } from 'next/dist/client/with-router';

import get from 'lodash/get';

import { postArticleUserStory } from 'state/actions/articleActions';

import { Form } from 'styled';

import Language from 'constants/Language';

import { GlobalState, FormValues } from 'types';

interface PassedProps {
  sharedStoryCount: number;
}

type Props = PassedProps &
  ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps> &
  WithRouterProps;

const ArticleUserStoryForm: FC<Props> = ({
  sharedStoryCount,
  globalSettings: { articleShareUserStory },
  postArticleUserStoryStatus,
  articles,
  actions: { postArticleUserStory },
  router: { query },
}) => {
  const articleSlug = (get(query, 'contentHubSlugs', []) as string[]).slice(
    -1
  )[0];

  const handleFormSubmit = (formValues: FormValues) => {
    postArticleUserStory(
      articleSlug,
      articles[`/${articleSlug}`].id,
      formValues
    );
  };

  return (
    <div className="ArticleUserStoryForm bg-color-white article-content-padding py2_5 md:py4_5">
      <div className="md:col-10 article-content-width">
        <div className="text-lg">
          <span>
            {!sharedStoryCount
              ? Language.t('ArticleUserStoryForm.shareYourStory')
              : Language.t('ArticleUserStoryForm.title', {
                  nounWithVerbToBe: `${sharedStoryCount} ${Language.t(
                    'ArticleUserStoryForm.other',
                    sharedStoryCount
                  )}`,
                })}
          </span>
        </div>
        <Form
          className="w100"
          color="gray-dark"
          description={articleShareUserStory.description}
          inputFields={articleShareUserStory.inputFields}
          handleSubmit={handleFormSubmit}
          formSubmitStatus={postArticleUserStoryStatus}
          submitButtonLabel={Language.t(
            'ArticleUserStoryForm.submitButtonLabel'
          )}
          title="ArticleUserStory"
        />
        <div className="mt4 md:mt4_5">
          <span className="text-secondary-xs">
            {articleShareUserStory.disclaimer}
          </span>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: GlobalState) => ({
  globalSettings: state.globalSettings,
  articles: state.article,
  postArticleUserStoryStatus: state.status.postArticleUserStoryStatus,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  actions: bindActionCreators(
    {
      postArticleUserStory,
    },
    dispatch
  ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ArticleUserStoryForm));
